import React from 'react';
import PropTypes from 'prop-types';
import './validationUi.css'

function ValidationUI(props) {

return(
    <div className="label-validate">
    <label className="validate-text">{props.label}</label>
    {props.click && <span role="button" className='text-policy' onClick={props.callbackfunc} onKeyDown={(e) => {if (e.key === 'Enter' || e.key === ' ') {}}} onMouseOver={ () => {} } onFocus={ () => {} }> {props.click}</span>}

    </div>
);
}

ValidationUI.propTypes = {
    label: PropTypes.string,
    click: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    callbackfunc: PropTypes.func,
};

export default ValidationUI;